import Vue from "vue"
import CreateNode from 'utils/createNode'
import Throttle from 'utils/throttling'

class Scaler {
    constructor(base = 1920) {
        this.base = Number(base)
        if (this.base < 1) return null

        // 对外属性
        this.outer = { base, now: 1, before: 1 }

        // 设置基础样式
        this.setBasicStyle()

        // 计算缩放
        this.scale = 1
        this.$scaleStyle = CreateNode('style', '', document.head)
        this.setScale()

        // 监听屏幕变化
        this.bindEv()

        return this.outer
    }

    setBasicStyle() {
        CreateNode(
            'style',
            `body {
        overflow-y: scroll
      }
      .scale-wrap {
        overflow: hidden;
        margin: 0 auto;
      }
      .scale{
        width: ${this.base}px;
        transform-origin: 0 0
      }
      .scale:before,
      .scale:after {
        content: "";
        display: table
      }
      .scale:after {
        clear: both
      }`,
            document.head
        )
    }

    setScale() {
        // 获取比值
        let width = document.documentElement.clientWidth
        this.scale = width > this.base ? 1 : width / this.base
        this.outer.before = this.outer.now
        this.outer.now = this.scale
        // 设置缩放样式
        if (this.scale === 1) {
            this.$scaleStyle.innerHTML = `.scale-wrap{width:${this.base}px;margin:0 auto}.scale{transform:scale3d(1,1,1)}`
        } else {
            this.$scaleStyle.innerHTML = `.scale-wrap{width:${width}px;margin:0 auto}.scale{transform-origin:0 0;transform:scale3d(${this.scale},${this.scale},1)}`
        }
    }

    bindEv() {
        window.addEventListener('resize', () => {
            // 节流
            Throttle(() => {
                this.setScale()
            })
        }, false)
    }
}

export default base => {
    const scaler = new Scaler(base)

    // 所有缩放盒子的元素列表
    const boxMap = new Map()

    // 计算裁剪值
    const decimalReg = /\d+(\.\d)?/
    function tofixed(num) {
        // 仅保留小数点后一位
        return decimalReg.exec(num)[0]
    }
    function caleOffset(el, wrap, force = false) {
        let { height } = getComputedStyle(el)

        if(!height) {
            return
        }
        
        let { now, before } = scaler

        // 内容没变化，且缩放没变化, 则略过
        let sameSize = height === el.dataset.height
        if (sameSize && now === before) {
            return
        }

        if (!sameSize) {
            el.dataset.height = height
        }


        height = parseFloat(height)
        wrap.style.height = `${tofixed(height * now)}px`
    }

    // 定时刷新
    let eventLoop
    function setEventLoop() {
        // 如果列表空了，则停止运行任务
        if (!boxMap.size) {
            clearInterval(eventLoop)
            eventLoop = null
            return
        }

        // 创建定时运行任务
        if (!eventLoop) {
            eventLoop = setInterval(() => {
                boxMap.forEach((el, wrap) => caleOffset(el, wrap))
                scaler.before = scaler.now
                // console.log(boxMap.size)
            }, 500)
        }
    }

    // vue组件化
    Vue.component("scale-box", {
        data() {
            return {
                box: null
            }
        },
        render(h) {
            return h('div', { class: 'scale-wrap' }, [
                h('div', { class: 'scale-box scale' }, [
                    this.$slots.default || h('i', { class: 'empty' })
                ])
            ])
        },
        mounted() {
            this.box = this.$el.querySelector('.scale-box')
            boxMap.set(this.$el, this.box)
            setEventLoop()
        }
    })

    // 覆写全局的路由变化方法
    Vue.prototype.$store.routerChange = () => {
        // 清理缩放列表里除页头页脚的所有元素
        boxMap.forEach((el, wrap) => {
            if(!/site\-(head|foot)/.test(wrap.parentNode.getAttribute('class'))) {
                boxMap.delete(wrap)
            }
        })
    }
}